import { createUseStyles } from 'react-jss'

import { COLOR, MQ } from 'utils/constants'

export const useStyles = createUseStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 1560,
    margin: 'auto',
  },
  gridContainer: {
    width: '80%',
    marginBottom: 100,
    display: 'grid',
    justifyItems: 'center',
    alignItems: 'center',
    [MQ.TABLET]: {
      gridTemplateColumns: '45% 45%',
      columnGap: '10%',
      gridTemplateRows: 'auto',
    },
    [MQ.TABLET_LARGE]: {
      gridTemplateColumns: '27.8% 27.8% 27.8%',
      columnGap: '8.33%',
    },
    [MQ.DESKTOP]: {
      marginBottom: 140,
    },
  },
  title: {
    color: COLOR.LIGHT_GREEN,
    textAlign: 'center',
    margin: [30, 0],
    width: '75%',
    [MQ.TABLET]: {
      margin: [40, 0],
    },
    [MQ.DESKTOP]: {
      margin: [0, 0, 70],
    },
  },
  tileWrapper: {
    display: 'flex',
    flexDirection: 'column',
    textDecoration: 'none',
    width: '100%',
    margin: [20, 0],

    [MQ.TABLET]: {
      margin: [25, 0],
    },
    [MQ.TABLET_LARGE]: {
      // width: '27.8%',
      margin: [60, 0],
    },
  },
})
